import { compose, flattenProp } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { addProps, addIntlProps } from 'utils/recompose';
import messages from '../messages';
import formatCurrency from 'utils/formatCurrency';
import { model } from 'reducers/models/selectors';
import combineSelectors from 'utils/combineSelectors';
import { seriesDetailPageLoaded } from 'reducers/loading/selectors';
import { addDisclaimer } from 'reducers/dashboard/selectors';
import { modelDescriptionLimit } from 'constants/values';
import styles from '../styles.module.scss';

const basePriceFormatted = formatCurrency({
  priceProp: 'basePrice',
  currencyProp: 'currency',
});

const mapStateToProps = combineSelectors({
  addDisclaimer,
  model,
  seriesDetailPageLoaded,
});

const modelTitleStyle = ({ model, addDisclaimer }) => {
  if (model && model.description) {
    const { description } = model;
    return description.length >= modelDescriptionLimit
      ? styles.smallModelTitle
      : styles.modelTitle;
  }
};

export default compose(
  connect(mapStateToProps),
  flattenProp('model'),
  injectIntl,
  addIntlProps({
    messages,
    propNames: ['basePriceLabel', 'currency'],
  }),
  addProps({
    basePriceFormatted,
    modelTitleStyle,
  }),
);
